<template>
  <div class="page">
    <van-cell-group>
      <van-cell title="工作证明" is-link @click="goPage('/cert-center-work')"/>
      <van-cell title="收入证明" is-link @click="goPage('/cert-center-income/')"/>
      <van-cell title="离职证明" is-link @click="goPage('/cert-center-leave')"/>
    </van-cell-group>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>

<style scoped>
.page {
  box-sizing: border-box;
}
</style>

<script>
import BindPersonnel from '@/components/BindPersonnel'
import mixinLoad from '@/mixin/mixin-load.js'

export default {
  name: 'HeTong',
  components: {BindPersonnel},
  mixins: [mixinLoad],
  data() {
    return {
      loading: true
    }
  },
  methods: {
    loadData() {
      this.loading = true
    },
    goPage(path) {
      this.$router.push({path});
    },
  },
  created() {
    Promise.all([this.preCheck()]).then(() => {
    })
    this.loadData()
  }
}
</script>
